import React from "react";
import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { ArrowLeft, ShieldCheck } from "lucide-react";

export default function ShowcaseAboutPage() {
  return (
    <div
      className="min-h-screen w-full"
      style={{ background: "hsl(var(--background))" }}
      data-testid="about-page"
    >
      <div className="showcase-header-band">
        <div className="max-w-[1200px] mx-auto px-4 sm:px-6 lg:px-8 pt-10 pb-6">
          <p className="eyebrow" style={{ color: "#3F4F66" }}>
            About
          </p>
          <h1
            className="font-heading text-3xl sm:text-4xl mt-1"
            style={{ color: "#1F1F1F", fontWeight: 600 }}
          >
            What you’re looking at
          </h1>
        </div>
        <div className="showcase-section-rule" />
      </div>

      <div className="max-w-[1200px] mx-auto px-4 sm:px-6 lg:px-8 py-8 space-y-6">
        <Button
          asChild
          variant="ghost"
          size="sm"
          className="gap-1.5 pl-1"
          data-testid="about-back-button"
        >
          <Link to="/showcase">
            <ArrowLeft size={14} strokeWidth={2.25} />
            Back to the dashboard
          </Link>
        </Button>

        <section className="showcase-card p-6 sm:p-8 max-w-3xl space-y-4">
          <p className="text-sm sm:text-base leading-relaxed text-foreground">
            This is a live progress view for the LiftTech portfolio. It shows what we’re
            building across seven products, what’s working, what’s waiting, and what
            the owner needs to look at.
          </p>
          <p className="text-sm sm:text-base leading-relaxed text-foreground">
            Everything you see is pulled from our team’s shared notebook. Each product
            team pushes a short progress update to the notebook, and this dashboard
            reads it every time you open the page. Technical shorthand is rewritten
            into plain English before you see it.
          </p>
        </section>

        <section className="showcase-card p-6 sm:p-8 max-w-3xl space-y-4">
          <h2
            className="font-heading text-xl sm:text-2xl"
            style={{ color: "#1F1F1F", fontWeight: 600 }}
          >
            How to read the statuses
          </h2>
          <ul className="space-y-2 text-sm sm:text-base leading-relaxed text-foreground">
            <li>
              <span className="font-semibold">On track</span> — the team is making
              progress; nothing is holding them up.
            </li>
            <li>
              <span className="font-semibold">Waiting on something</span> — the team
              is ready but is waiting on a decision, a person, or an outside vendor.
            </li>
            <li>
              <span className="font-semibold">Blocked</span> — something needs to move
              before this product can advance.
            </li>
            <li>
              <span className="font-semibold">Between phases</span> — finished the
              last chunk of work; starting the next one shortly.
            </li>
          </ul>
        </section>

        <section className="showcase-card p-6 sm:p-8 max-w-3xl">
          <div className="flex items-start gap-3">
            <ShieldCheck
              size={22}
              strokeWidth={2}
              style={{ color: "#067647", marginTop: 2 }}
              aria-hidden
            />
            <div>
              <h2
                className="font-heading text-xl sm:text-2xl mb-2"
                style={{ color: "#1F1F1F", fontWeight: 600 }}
              >
                A note on privacy
              </h2>
              <p className="text-sm sm:text-base leading-relaxed text-foreground">
                No credentials, keys, passwords, or account details are ever shown on
                this dashboard. If any technical value appears in the source notebook,
                it is automatically hidden before this page can render it.
              </p>
            </div>
          </div>
        </section>
      </div>
    </div>
  );
}
